import { cn, Typography } from "@kyan/ui";
import { type ReactNode } from "react";

interface FormInfoProps {
  title: ReactNode;
  info?: ReactNode;
  className?: string;
}

export const FormInfo: React.FC<FormInfoProps> = ({
  title,
  info,
  className = "mt-4 mb-1",
}) => {
  return (
    <Typography
      size={12}
      className={cn("flex w-full items-center justify-between", className)}
    >
      {title}
      <Typography variant="secondary">{info}</Typography>
    </Typography>
  );
};
